import classnames from 'classnames';
import React__default, { useRef, useState } from 'react';
import { Switch } from 'radix-ui';
import styles from './index.module.scss.js';

const Toggle = ({ children: label, weight = 'book', spaceBetweenElements = false, name, checked, disabled = false, defaultChecked = false, onInputChange, classes = [], reverse = false, }) => {
    const { current: isControlled } = useRef(checked !== undefined);
    const [value, setValue] = useState(defaultChecked);
    const checkedValue = isControlled ? checked : value;
    const setValueIfUncontrolled = (newValue) => {
        if (!isControlled) {
            setValue(newValue);
        }
    };
    const handleInputChange = (changedValue) => {
        setValueIfUncontrolled(changedValue);
        onInputChange?.(changedValue);
    };
    return (React__default.createElement("div", { className: classnames(styles.content, classes, {
            [styles.spaced]: spaceBetweenElements,
        }) },
        React__default.createElement("label", { className: classnames(styles.label, {
                [styles.semibold]: weight === 'semibold',
                [styles.reverse]: reverse,
                [styles.disabled]: disabled,
            }), htmlFor: name }, label),
        React__default.createElement(Switch.Root, { name: name, id: name, checked: checkedValue, onCheckedChange: handleInputChange, defaultChecked: defaultChecked, disabled: disabled, className: classnames(styles.switchRoot, {
                [styles.disabled]: disabled,
            }) },
            React__default.createElement(Switch.Thumb, { className: styles.switchThumb }))));
};

export { Toggle };
//# sourceMappingURL=index.js.map
